import axios from "axios";
import { create } from "zustand";

const initialState = {
  loading: false,
  success: false,
  error: false,
  errorData: null,
  products: null,
  formatted_string: null,
  shouldUseBundleTitle: false,
  paymentsConfig: null,
  emailMarketingConfig: null,
};

export const useProductData = create((set, get) => ({
  ...initialState,
  get: async ({ postId, isMobile, affParam, affSourceParam }) => {
    set({ ...initialState, loading: true });
    try {
      const productPackEndpoint = "/wp-json/core/products/v1/product_pack/";
      const res = await axios.post(productPackEndpoint, {
        postId,
        isMobile,
        affParam,
        affSourceParam,
      });
      const productSettings = res?.data.products;
      const shouldUseBundleTitle = productSettings?.show_bundle_design || productSettings?.show_product_picker_v2;

      set({
        ...initialState,
        success: true,
        products: res?.data?.products?.products,
        ...res?.data.products,
        formatted_string: res?.data.formatted_string,
        country_code: res?.data?.country?.toUpperCase(),
        shouldUseBundleTitle: shouldUseBundleTitle,
        paymentsConfig: res?.data?.paymentsConfig,
        emailMarketingConfig: res?.data?.emailMarketingConfig,
      });
    } catch (err) {
      set({ ...initialState, error: true, errorData: err.message });
    }
  },
  changeProductsShippingPrice: (shippingPrice) => {
    return set((state) => ({
      ...state,
      products:
        state?.products?.length > 0 &&
        state?.products?.map((product) => ({
          ...product,
          shipping_price: shippingPrice,
        })),
    }));
  },
}));
